import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'
import { getToken, LogBack } from '@/utils/auth'
import {
  handleErrors
} from '@/utils/helper/requestHelper'

// create an axios instance
const service = axios.create({
  baseURL: '', // url = base url + request url
  timeout: 1000000 // request timeout
})

// 根据环境变量决定主备地址，确保与 token 签发域一致
// 生产环境 token 由 mjapi 签发，测试环境 token 由 mjapitest 签发
const isDev = process.env.NODE_ENV === 'development'
const dev = 'https://mjapi.seedear.net/api/ai/d/remark' // 上线地址
const test = 'https://mjapitest.seedear.net/api/ai/d/remark' // 测试地址（修正大小写，与 VUE_APP_BASE_API 一致）
// 开发环境优先连接测试服务器（与 token 签发域一致），生产环境优先连接生产服务器
const primaryURL = isDev ? test : dev
const fallbackURL = isDev ? dev : test
let defaultURL = ''
// return config
export const getdefaultURL = () => { return defaultURL }

// request interceptor
service.interceptors.request.use(
  async config => {
    // 如果已经有缓存的 baseURL，直接使用，避免每次请求都探测
    if (defaultURL) {
      setAuthHeader(config)
      config.baseURL = defaultURL
      return config
    }
    try {
      // 先测试主地址是否可用
      const testRes = await axios.get(primaryURL, {
        params: {
          type: 'ai/d/m/home',
          page: 1,
          limit: 99999
        },
        timeout: 5000
      })
      if (testRes.status === 200) {
        setAuthHeader(config)
        config.baseURL = primaryURL
        defaultURL = config.baseURL
        return config
      }
    } catch (error) {
      // 主地址失败，尝试备用地址
      try {
        const testRes = await axios.get(fallbackURL, {
          params: {
            type: 'ai/d/m/home',
            page: 1,
            limit: 99999
          },
          timeout: 5000
        })
        if (testRes.status === 200) {
          setAuthHeader(config)
          config.baseURL = fallbackURL
          defaultURL = config.baseURL
          return config
        }
      } catch (fallbackError) {
        console.error('[讨论区请求] 主备地址均不可用:', fallbackError)
      }
    }
  },
  error => {
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

function setAuthHeader(config) {
  if (store.getters.token) {
    config.headers['Authorization'] = 'Bearer ' + getToken()
  }
}

// response interceptor
service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 20000 || res.code === 20010) {
      return res
    }
    // 处理错误状态码
    if (!handleErrors(res)) {
      return
    }
    Message({
      dangerouslyUseHTMLString: true,
      showClose: true,
      message: res.message.toString() || 'Error',
      type: 'error',
      duration: 2500
    })
    return Promise.reject(new Error(res.message || 'Error'))
  },
  error => {
    const originalRequest = error.config
    if (error.code === 'ECONNABORTED' && error.message.indexOf('timeout') !== -1 && !originalRequest._retry) {
      Message({
        showClose: true,
        message: '请求超时',
        type: 'error',
        duration: 2500
      })
      return Promise.reject(error)
    }
    // 安全访问 response 对象
    const response = error.response
    if (!response) {
      Message({
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: error.message || '网络异常，请检查网络连接',
        type: 'error',
        duration: 2500
      })
      return Promise.reject(error)
    }
    // 仅在 401 状态码下检查 authorization 头
    if (response.status === 401 && response.headers && response.headers.authorization) {
      LogBack('您登录已过期，请重新登录')
    } else if (response.data && response.data.message === 'The token has been blacklisted') {
      LogBack('您登录已过期，请重新登录')
    } else if (response.status === 401) {
      Message({
        showClose: true,
        message: '请先登录',
        type: 'error',
        duration: 2500
      })
    } else if (response.status === 422) {
      const errorMsg = response.data
      let msg = ''
      const data = errorMsg.errors

      Object.keys(data).forEach(function (key) {
        for (const k in data[key]) {
          msg += data[key][k] + '  '
        }
      })
      Message({
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: msg,
        type: 'error',
        duration: 2500
      })
    } else {
      Message({
        dangerouslyUseHTMLString: true,
        showClose: true,
        message: error.message,
        type: 'error',
        duration: 2500
      })
    }
    return Promise.reject(error)
  }
)

export default service
